import { FormattedMessage } from 'react-intl'
import { createUrl } from 'localized-urls'
import { createLoginUrl, isAffiliate, isLoggedIn, isStaff } from '../../utils'
import { AffiliateSuccessText } from './checkout-success'
import isEmpty from 'lodash/isEmpty'
import LiveaboardRequirementsText from './checkout-success/LiveaboardRequirementsText'
import CertificationCard from './CertificationCard'

export default function CheckoutSuccess({ order, kind }) {
  if(isEmpty(order)) {
    return null
  }
  if(isAffiliate()) {
    return <AffiliateSuccessText />
  }

  if(order.orderUpdated) {
    return (
      <div className='congrats'>
        <CertificationCard />
        <FormattedMessage
          id='thank_you'
          defaultMessage='Thank you'
          tagName='h2'
        />
        <FormattedMessage
          id='your_booking_updated'
          defaultMessage='We have received your updated booking request!'
          tagName='h3'
        />

        <FormattedMessage
          id='your_booking_updated.text'
          defaultMessage={`We'll send you a final Booking Confirmation Email on average within 24 hours once we receive response from the operator. We advise you to not make any other travel arrangements before that.`}
          tagName='p'
        />

        <a className='btn-red-invert mtm' href={createUrl('bookings')}>
          <FormattedMessage
            id='view_booking_in'
            defaultMessage='View booking in my account'
          />
        </a>
      </div>
    )
  }

  return (
    <div className='congrats'>
      <CertificationCard />
      <FormattedMessage
        id='congratulations'
        defaultMessage='Congratulations'
        tagName='h2'
      />

      <div>
        <br />
        <FormattedMessage
          id='dear_guest'
          defaultMessage='Dear {name}'
          values={{ name: order.firstName }}
          tagName='p'
        />
        <FormattedMessage
          id='checkout.thanks.resort'
          defaultMessage='Thank you for booking with PADI Travel! We will now double check availability with the dive operator and send you a booking confirmation Email within 24 hours. We recommend that you not make any other travel arrangements before that.'
          tagName='p'
        />

        <div className='order-reference'>
          <FormattedMessage
            id='checkout.reference'
            defaultMessage='Please make a note of the following booking reference, which must be quoted in all communications with us regarding this booking:'
            tagName='p'
          />
          <span className='reference-id'>{order.reference}</span>
        </div>
      </div>
      {kind === 10 && order.requirements && (
        <LiveaboardRequirementsText requirements={order.requirements} />
      )}

      {isLoggedIn() ? (
        <div>
          <a className='btn-red-invert small-btn' href={createUrl('bookings')}>
            <FormattedMessage
              id='view_booking_in'
              defaultMessage='View booking in my account'
            />
          </a>
          {isStaff() ? (
            <a className='btn-red small-btn' href={process.env.INTRANET_URL}>
              <FormattedMessage
                id='back_to_intranet'
                defaultMessage='Back to the Intranet'
              />
            </a>
          ) : (
            <a className='btn-red small-btn' href={createUrl('homepage')}>
              <FormattedMessage
                id='back_to_homepage'
                defaultMessage='Back to the homepage'
              />
            </a>
          )}
        </div>
      ) : (
        <div className='checkout-register'>
          <div>
            <h3>
              <FormattedMessage
                id='register_ask_header'
                defaultMessage='Next step'
              />
            </h3>
            <p>
              <FormattedMessage
                id='register_ask_text'
                defaultMessage='Register to be able to manage your bookings'
              />
            </p>
          </div>
          <div className='link-container'>
            <a
              className='btn-red-invert small-margin'
              href={createLoginUrl('bookings')}
            >
              <FormattedMessage
                id='create_my_acc'
                defaultMessage='Create my account'
              />
            </a>
          </div>
        </div>
      )}
    </div>
  )
}
